import { render } from "./shoppingCartViewer.vue?vue&type=template&id=6ff15f68&ts=true"
import script from "./shoppingCartViewer.vue?vue&type=script&lang=ts"
export * from "./shoppingCartViewer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__